module.exports = __webpack_public_path__ + "img/pocket-4_en.a9a2cf6.jpg";